import { CALL_HISTORY_METHOD, LOCATION_CHANGE } from 'connected-react-router';
import * as TagManager from 'react-gtm-module';
import { AnyAction, Dispatch } from 'redux';

const pageviewActionTypes = new Set([LOCATION_CHANGE, CALL_HISTORY_METHOD]);

const gtmLocationChangeMiddleware = () => (next: Dispatch<AnyAction>) => (action: AnyAction) => {
  if (pageviewActionTypes.has(action.type)) {
    const tagManagerArgs = {
      dataLayer: {
        event: 'pageview-react',
        location: action.payload.location,
      },
      dataLayerName: CONFIG.gtm.dataLayer,
    };

    TagManager.dataLayer(tagManagerArgs);
  }

  return next(action);
};

export { gtmLocationChangeMiddleware };
